var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 479.925 479.925",
    style: {
      enableBackground: "new 0 0 479.925 479.925"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.924,171.856c0-0.6,0-1.2,0-1.8c0.036-75.111-60.825-136.029-135.936-136.064     C242.303,33.97,199.659,56.888,174.468,95c-50.35-16.807-104.792,10.385-121.599,60.735c-3.263,9.777-4.933,20.014-4.945,30.321     c0,0.68,0,1.368,0,2.056c-34.211,8.887-54.74,43.825-45.853,78.035c7.32,28.179,32.738,47.867,61.853,47.909h143.472     c4.418,0,8-3.582,8-8s-3.582-8-8-8H63.924c-26.509-0.158-47.871-21.775-47.714-48.284c0.141-23.766,17.653-43.85,41.178-47.228     c4.232-0.569,7.271-4.362,6.904-8.616c-0.216-2.576-0.368-5.224-0.368-7.872c0.057-44.24,35.967-80.058,80.207-80.001     c10.491,0.013,20.877,2.088,30.569,6.105c3.673,1.526,7.91,0.122,9.944-3.296c33.745-57.04,107.34-75.924,164.38-42.18     c36.535,21.614,58.932,60.922,58.9,103.372c0,2.648-0.072,5.216-0.288,7.792c-0.371,4.304,2.742,8.125,7.032,8.632     c30.694,3.798,52.497,31.759,48.699,62.453c-3.465,28.004-27.225,49.056-55.443,49.123c-2.406,0.003-4.811-0.138-7.2-0.424     c-1.148-0.141-2.314,0.005-3.392,0.424H271.636c-4.418,0-8,3.582-8,8s3.582,8,8,8h128.288c0.611-0.002,1.219-0.085,1.808-0.248     c2.024,0.168,4.096,0.248,6.192,0.248c39.765,0.001,72.001-32.234,72.001-71.999     C479.926,208.456,456.685,179.322,423.924,171.856z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#00B4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.148,364.4l-54.224,54.224V194.056c0-4.418-3.582-8-8-8s-8,3.582-8,8v224.568L177.7,364.4     c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116l67.88,67.88c3.124,3.123,8.188,3.123,11.312,0     l67.88-67.88c3.07-3.178,2.982-8.242-0.196-11.312C310.164,361.405,305.248,361.405,302.148,364.4z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#00B4F2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4f8b07e2.svg";
export { ForwardRef as ReactComponent };